import axios from 'axios'

export default class AtualizacaoBeneficiario {
  constructor (tokenBearer, url, id) {
    this.url = url
    this.tokenBearer = tokenBearer
    this.id = id
  }

  getUnimeds (args = '') {
    let url = `${this.url}/api/atualizacaoBeneficiario/unimeds?${args}`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAllUnimeds (args = '') {
    let url = `${this.url}/api/atualizacaoBeneficiario/cadbenef/unimeds?${args}`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  putAtualizar (data) {
    let url = `${this.url}/api/atualizacaoBeneficiario/atualizar`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'put',
        url,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  atualizarCompetenciaCadbenef (competencia, idsUnimed, reenviarComErro) {
    return new Promise(async (resolve, reject) => {
      let option = {
        method: 'PUT',
        url: `${this.url}/api/cadbenef/competencia/beneficiarios`,
        headers: {
          Authorization: this.tokenBearer
        },
        data: {
          competencia: competencia,
          codigoUnimed: idsUnimed,
          reenviarComErro: reenviarComErro
        }
      }
      try {
        let response = await axios(option)
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }
}
